export default __webpack_public_path__ + "static/media/tqicon-1.4918c451.svg";